
import firebase from 'firebase';

export const firebaseConfig = {
    apiKey: "AIzaSyBLRbBlOidZu0GIj4szOHgvpG-52b93yL0",
    authDomain: "ayo-desenvolvimento.firebaseapp.com",
    databaseURL: "https://ayo-desenvolvimento.firebaseio.com",
    projectId: "ayo-desenvolvimento",
    storageBucket: "ayo-desenvolvimento.appspot.com",
    messagingSenderId: "437216398648",
    appId: "1:437216398648:web:0fc78b257e609b8d1885cd",
    measurementId: "G-CSL9QPHVJ2"
};


firebase.initializeApp(firebaseConfig);

export default firebase;